import React from "react";
import { Flex, Text, Box, Grid } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import HazardsCards from "./hazardsCards";
import AiNotes from "./AiNotes";
import IncidentsCard from "./incidentsCard";
import RecentRiskCard from "./recentRiskCard";

const ChatbotDashboard: React.FC = () => {
  const { t } = useTranslation("common");

  const sections = [
    {
      id: 1,
      component: <HazardsCards />,
    },
    {
      id: 2,
      component: <AiNotes />,
    },
    {
      id: 3,
      component: <IncidentsCard />,
    },
    {
      id: 4,
      component: <RecentRiskCard />,
    },
  ];

  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={6} p={4}>
      {sections?.map((section) => (
        <Box key={section.id}>{section.component}</Box>
      ))}
    </Grid>
  );
};

export default ChatbotDashboard;
